import type { CompanyDiscoveryAiOutput } from '@revelio/data-access';

import { dashMetaFetch } from '../../../../shared/api/dash-meta-fetch';
import { getAiSearchCsrfToken } from './ai-search-api-request';

export const screenerAiSearchRequest = async ({
  prompt,
  geoTax,
  signal,
}: {
  prompt: string;
  /**
   * The user's geography taxonomy id (metro 1 / administrative 2). When
   * omitted, the backend resolves geography under the metro tree.
   */
  geoTax?: number;
  signal?: AbortSignal;
}): Promise<{
  response: CompanyDiscoveryAiOutput;
  uuid: string;
}> => {
  const csrfToken = await getAiSearchCsrfToken();
  const response = await dashMetaFetch('/api/ai-search/company-screener', {
    method: 'POST',
    headers: { 'x-surf-token-dash-meta-ai-search': csrfToken },
    body: JSON.stringify({
      text: prompt,
      ...(geoTax !== undefined ? { geo_tax: geoTax } : {}),
    }),
    signal,
  });
  if (!response.ok) {
    throw new Error(
      `Screener AI search request failed: ${response.status} ${response.statusText}`
    );
  }
  const data: unknown = await response.json();
  return data as {
    response: CompanyDiscoveryAiOutput;
    uuid: string;
  };
};
